module.exports = __webpack_public_path__ + "img/resistance.29b9bfee.png";